import { forwardRef, Input } from '@angular/core'
import { Component } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'action-toolbar-search',
    templateUrl: './action-toolbar-search.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ActionToolbarSearchComponent),
            multi: true,
        },
    ],
    standalone: true,
    imports: [FaIconComponent, FormsModule],
})
export class ActionToolbarSearchComponent implements ControlValueAccessor {
    faSearch = faSearch
    @Input() search = ''
    modelChangeFn(value: any) {
        this.propagateChange(value)
    }
    writeValue(value: any) {
        if (value !== undefined) {
            this.search = value
        }
    }
    propagateChange = (_: any) => {}
    registerOnChange(fn) {
        this.propagateChange = fn
    }
    registerOnTouched() {}
}
